import { Component, Inject } from '@angular/core';
import { Restangular } from 'ngx-restangular';
import { Main } from '../core/main.service';
import { EkubService } from './ekub.service';
// import { Router } from '@angular/router';

@Component({
  selector: 'cp-ekubs',
  templateUrl: './ekubs.component.html',
  styleUrls: ['./ekubs.component.scss']
})

export class EkubsComponent {
  filter: string;
  itemsPerPage: number;
  totalItems: number;
  currentPage: number;
  ekubs: any = [];

  constructor(@Inject(Restangular) public Restangular, private mainService: Main, private api: EkubService) {
    this.filter = '&type=';
    this.itemsPerPage = 10;
    this.totalItems = 0;
    this.currentPage = 1;
    this.getEkubFilter('');
  }

  getEkubFilter(filter: any) {
    this.filter = filter;
    this.getEkubs();
  }

  getEkubs() {
    let j = this.itemsPerPage * this.currentPage - this.itemsPerPage;
    this.api.getEkubs('page=' + this.currentPage + this.filter).subscribe((resp: any) => {
      this.ekubs = resp.data;
      for (let i = 0; i < this.ekubs.length; i++) {
        this.ekubs[i].no = j + 1;
        j++;
      }
      this.totalItems = resp.meta.pagination.total;
      this.itemsPerPage = resp.meta.pagination.per_page;
    }, (err) => {
      this.mainService.toast({ title: 'Error', body: err.statusText, type: 'danger' });

    });
  }

  pageChanged(event: any) {
    event = event;
    this.currentPage = this.currentPage;
    this.getEkubs();
  }

  changeStatus(id: any, status: any) {
    this.api.changeEkubStatus(id, status).subscribe((res: any) => {
      this.mainService.toast({ title: 'Success', body: res.data.title, type: 'dark' });
      this.getEkubs();
    }, (err) => {
      this.mainService.toast({ title: 'Error', body: err.statusText, type: 'error' });

    });
  }

}
